import { Theme } from '@mui/material/styles';
import { Box, useMediaQuery, Grid, Chip, Dialog, Badge } from '@mui/material';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';
import { MenuOrientation, ThemeMode } from 'types/config';
import { Diagram, Refresh, Send, ShieldTick } from 'iconsax-react';
import { useEffect, useState } from 'react';
import serverCall from 'api/serverCall';
import api from 'api/api';
import { openSnackbar } from 'store/reducers/snackbar';
import { useStatusContext } from 'contexts/StatusContext';
import IconButton from 'components/@extended/IconButton';
import { useTheme } from '@mui/material/styles';
import WatchListDrawer from './WatchListDrawer';
import IndiaFlag from 'assets/images/common/INDIA.svg';
import USAFlag from 'assets/images/common/USA.svg';
import { useDataContext } from 'contexts/DataContext';
import { Country } from 'types/custom/data';
import { dispatch } from 'store';
import OrderRequest from './OrderReqeust';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import RecommendationOrderRequest from './RecommendationOrderRequest';
import { useWebsocketContext } from 'contexts/WebSocketContext';
import { PopupTransition } from 'components/@extended/Transitions';
import { KiteConnectModal } from './KiteConnectModal';
import { useNavigate } from 'react-router';
// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation } = useConfig();
  const { kiteStatus, setKiteStatus, tickKiteStatus } = useStatusContext();
  const { country } = useDataContext();
  const { orderRequestStatus, recommendation, orderStatusChanged } = useWebsocketContext();
  const [orderRequestCount, setOrderRequestCount] = useState<number>(0);
  const [recommendationRequestCount, setRecommendationRequestCount] = useState<number>(0);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const theme = useTheme();
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const submitTokenToServer = (requestToken: string) => {
    const requestBody = {
      requestToken
    };
    serverCall.put(api.createZerodhaConnection(), requestBody, (response, error) => {
      if (error) {
        console.error(error);
      } else {
        setKiteStatus(true);
      }
    });
  };

  const submitAccessTokenToServer = (accessToken: string, publicToken: string) => {
    serverCall.put(api.submitAccessTokenToServer(accessToken, publicToken), {}, (response, error) => {
      if (error) {
        console.error(error);
      } else {
        setKiteStatus(true);
      }
    });
  };

  const handleConnect = () => {
    setOpenModal(true);
    // serverCall.get(api.getZerodhaLoginUrlAdmin(), (response, error) => {
    //   if (error) {
    //     console.error(error);
    //   } else {
    //     window.open(response, '_self');
    //   }
    // });
  };

  const handleSendToken = async () => {
    const searchParams = new URLSearchParams(window.location.search);

    const zerodhaRequestToken = searchParams.get('request_token');

    if (zerodhaRequestToken) {
      if (!kiteStatus) {
        submitTokenToServer(zerodhaRequestToken);
        // searchParams.delete('request_token');
        // const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
      }
    }
  };

  const handleAccessToken = async () => {
    const searchParams = new URLSearchParams(window.location.search);

    const accessToken = searchParams.get('accessToken');
    const publicToken = searchParams.get('publicToken');

    console.log(accessToken, publicToken);

    if (accessToken && publicToken) {
      if (!kiteStatus) {
        submitAccessTokenToServer(accessToken, publicToken);
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
      }
    }
  };

  const handleCheckStatus = () => {
    serverCall.get(api.getZerodhaKiteConnectStatus(), (response, error) => {
      if (error) {
        dispatch(
          openSnackbar({
            open: true,
            close: true,
            message: `Failed to check status`,
            variant: 'alert',
            alert: {
              color: 'error'
            },
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center'
            }
          })
        );
      } else {
        if (response.connected) {
          dispatch(
            openSnackbar({
              open: true,
              close: true,
              message: `Kite status: Connected`,
              variant: 'alert',
              alert: {
                color: 'success'
              },
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
              }
            })
          );
        } else {
          dispatch(
            openSnackbar({
              open: true,
              close: true,
              message: `Kite status: Not Connected`,
              variant: 'alert',
              alert: {
                color: 'error'
              },
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
              }
            })
          );
        }

        setKiteStatus(response.connected);
      }
    });
  };

  useEffect(() => {
    handleSendToken();
    handleAccessToken();
  }, [window.location.search, kiteStatus]);

  useEffect(() => {
    serverCall.get(api.getAllPendingOrders(), (response, error) => {
      if (!error) {
        setOrderRequestCount(response.totalCount);
      }
    });
  }, [orderRequestStatus, orderStatusChanged]);

  useEffect(() => {
    serverCall.get(api.getAllPendingOrdersForRecommendation(), (response, error) => {
      if (!error) {
        setRecommendationRequestCount(response.totalCount);
      }
    });
  }, [orderRequestStatus, recommendation]);

  //TODO: FIX
  // useEffect(() => {
  //   if (!kiteConnectStatus && !tokenGenerated) {
  //     setOpenKiteConnectModal(true);
  //   }
  // }, [kiteConnectStatus, tokenGenerated]);

  const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'secondary.100';

  return (
    <>
      <Dialog
        maxWidth="sm"
        fullWidth
        TransitionComponent={PopupTransition}
        // onClose={handleAdd}
        open={openModal}
        sx={{ '& .MuiDialog-paper': { p: 0 } }}
      >
        <KiteConnectModal
          open={openModal}
          handleCancel={() => setOpenModal(false)}
        />
      </Dialog>
      <Grid container justifyContent="space-between">
        <Grid item>
          {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
          {/* {!downLG && <Search />} */}
        </Grid>
      </Grid>
      {/* {!downLG && megaMenu} */}
      {/* {!downLG && localization} */}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      <div data-tooltip-id="header-tooltip" data-tooltip-content="Kite status">
        <Grid sx={{ mr: 1 }} item xs={12} sm="auto">
          {/* <Chip
          label=""
          icon={<Refresh style={{ marginLeft: '12.5px' }} />}
          clickable
          color="primary"
          size="small"
          variant="light"
          onClick={handleCheckStatus}
          sx={{ borderRadius: '20px', mr: '10px' }}
        /> */}
          {kiteStatus ? (
            <Chip icon={<ShieldTick />} color={'success'} label="Market Live" size="small" onClick={() => setOpenModal(true)} clickable />
          ) : (
            <Chip
              label="Connect"
              icon={<Send />}
              clickable
              color="primary"
              size="small"
              onClick={handleConnect}
              sx={{ borderRadius: '20px' }}
            />
          )}
        </Grid>
      </div>
      <div data-tooltip-id="header-tooltip" data-tooltip-content="Country">
        <IconButton
          color="secondary"
          variant="light"
          aria-label="country"
          aria-haspopup="true"
          size="large"
          sx={{ color: 'secondary.main', bgcolor: iconBackColor, p: 1, mr: 0.5 }}
        >
          {country === Country.in ? (
            <img src={IndiaFlag} alt="India Flag" style={{ width: 30, height: 30 }} />
          ) : (
            <img src={USAFlag} alt="USA Flag" style={{ width: 30, height: 30 }} />
          )}
        </IconButton>{' '}
      </div>
      <div data-tooltip-id="header-tooltip" data-tooltip-content="Refresh Kite status">
        <IconButton
          color="secondary"
          variant="light"
          aria-label="open profile"
          // ref={anchorRef}
          // aria-controls={open ? 'profile-grow' : undefined}
          aria-haspopup="true"
          onClick={handleCheckStatus}
          size="large"
          sx={{ color: 'secondary.main', bgcolor: iconBackColor, p: 1 }}
        >
          <Refresh variant="Bold" />
        </IconButton>{' '}
      </div>
      {/* <Grid item xs={12} sm="auto">
        <Chip
          icon={active ? <Flash variant="Bold" /> : <FlashSlash variant="Bold" />}
          color={active ? 'success' : 'error'}
          label="Server"
          size="small"
        />
      </Grid> */}
      <div data-tooltip-id="header-tooltip" data-tooltip-content="Live Ticks" aria-disabled={true}>
        <Box sx={{ flexShrink: 0, ml: 0.75 }}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            variant="dot"
            color={tickKiteStatus ? 'success' : 'error'}
            sx={{
              '& .MuiBadge-badge': {
                width: 10,
                height: 10,
                borderRadius: '50%',
                minWidth: 10,
                boxShadow: '0 0 0 2px white',
              }
            }}
          >
            <IconButton
              color="secondary"
              variant="light"
              size="large"
              sx={{ color: 'secondary.main', bgcolor: iconBackColor, p: 1 }}
              onClick={() => navigate('/live-tick-status')}
            >
              <Diagram variant="Bold" />
            </IconButton>
          </Badge>
        </Box>
      </div>
      <div data-tooltip-id="header-tooltip" data-tooltip-content="Notifications">
        <Notification />
      </div>
      <div data-tooltip-id="header-tooltip" data-tooltip-content="Order Request">
        <OrderRequest orderRequestCount={orderRequestCount} setOrderRequestCount={setOrderRequestCount} />
      </div>
      <div data-tooltip-id="header-tooltip" data-tooltip-content="Recommendation Request">
        <RecommendationOrderRequest
          setRecommendationRequestCount={setRecommendationRequestCount}
          recommendationRequestCount={recommendationRequestCount}
        />
      </div>
      <div data-tooltip-id="header-tooltip" data-tooltip-content="Watch List">
        <WatchListDrawer />
      </div>
      <div data-tooltip-id="header-tooltip" data-tooltip-content="Profile">
        {!downLG && (
          <Profile
            setOrderRequestCount={setOrderRequestCount}
            orderRequestCount={orderRequestCount}
            setRecommendationRequestCount={setRecommendationRequestCount}
            recommendationRequestCount={recommendationRequestCount}
          />
        )}
      </div>
      {downLG && (
        <MobileSection
          setOrderRequestCount={setOrderRequestCount}
          orderRequestCount={orderRequestCount}
          setRecommendationRequestCount={setRecommendationRequestCount}
          recommendationRequestCount={recommendationRequestCount}
        />
      )}
      <Tooltip
        id="header-tooltip"
        place="bottom"
        style={{
          backgroundColor: theme.palette.secondary.light, // variant="light"
          color: theme.palette.secondary.main, // color="secondary"
          padding: theme.spacing(1), // p: 1
          fontSize: '12px',
          borderRadius: '6px',
          boxShadow: theme.shadows[2]
        }}
      />
      {/* {openKiteConnectModal && (
        <ConnectKiteDialog setTokenGenerated={setTokenGenerated} open={openKiteConnectModal} handleClose={setOpenKiteConnectModal} />
      )} */}
    </>
  );
};

export default HeaderContent;
